export class OptIn {
    _id: string;
    user: any;
    email: string;
    phone: string;
    ipAddress: string;
    consentLanguage: string;
    smsOptIn: boolean;
    emailPhoneOptIn: boolean;
    confirmationSent: boolean;
    deleted: boolean;
    createdAt: Date;
    updatedAt: Date;
}
